import Topbar from "../mobiles/Topbar.vue";
export default {
  components: {
    Topbar
  }
};